<div class="page-header">
    <nb-icon class="back-button" (click)="back()" icon="chevron-left-outline"></nb-icon>
    <div>{{title}}</div>
</div>

<div class="page-content">
   <nb-card>
       <nb-card-body [innerHtml]="notes"></nb-card-body>
   </nb-card>
</div>